import * as Sentry from '@sentry/browser';

export function initSentry() {
    if (process.env.NODE_ENV !== 'production') {
        return;
    }

    Sentry.init({
        dsn: process.env.SENTRY_DSN_JS,
        environment: process.env.APP_ENV ?? 'dev',
        release: process.env.SENTRY_RELEASE || 'local-dev',
        sendDefaultPii: true,
        tracesSampleRate: 1,

        beforeSend(event, hint) {
            if (hint.originalException?.ignoreSentry) {
                return null
            }

            return event
        }
    });
}
